module.exports = __webpack_public_path__ + "img/cybermir_preloader_hud.372ef240.svg";